export default {
  volume: "Volumen",
  axles: "Ejes",
  radiusOfCurvature: "Radio de curvatura",
  maxLoad: "Carga Máxima",
  overAllLength: "Longitud total",
  weighingLength: "Longitud de pesaje",
  wagonType: "Tipo de vagón",
  tareWeight: "Peso en vacío",
  yearOfConstruction: "Año de construcción",
  size: "Tamaño",
  technicalSpecification: "Especificaciones Técnicas",
};
